import type { FaireProductEntity } from "../../entity_types/product";

export const p_f7857u7xy7: FaireProductEntity = {
  token: "p_f7857u7xy7",
  type: "product",
  name: "Alabama: Novelty Mahjong Playing Card (Set of 4)",
  brandToken: "b_m2upumjee3",
  brandName: "Mahjong & Magnolias",
  imageUrl:
    "https://cdn.faire.com/fastly/60c235924e44c0044bf256f4b041267ed24c1bec2031ac01ca714686995ef32a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ed9484d0cb2c6832d87ba4f6ca43dd4c2ffae49d0920793101caadd9fb7ac17.jpeg",
    "https://cdn.faire.com/fastly/73a46d53bdbb55600e5250fccbd2284fd64f752fe183f1560cb234a4aa6899cd.png",
    "https://cdn.faire.com/fastly/4531c71120f13025238689a84bf3fcaead25659a2931759b83e1582ebaa7ee84.png",
  ],
  priceDollars: 24,
  description:
    "A delightful alternative to the standard National Mahjong League card.  Our cards use the same tiles and the same rules as American Mahjong but a unique legend. Our cards have a wordplay twist and use tiles to spell words like Gulf Shores, Harper Lee and Meat & 3. \n\nOur matte laminate cards are sold in sets of four so the whole group is ready to play.\n\nCheck out our video to hear more.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:51.355Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
